import { lazy, Suspense, ReactElement } from 'react';
// import PageLoadingScreen from "@/components/PageLoadingScreen";
import LoadingImg from '@/assets/images/spaceSymbol.png'

interface Props {
    componentPath?: string,
    element?: ReactElement,
}

const LazyRouteElement = ({componentPath, element}:Props) => {
    let Comp;
    if (!!componentPath) {
        const to = `../pages/${componentPath}`;
        Comp = lazy(() => import(/* @vite-ignore */to).then(module => (module)))
    }

    const children = element || (<div>No Page</div>);

    return (
        <Suspense
            fallback={(
                <div style={{width: '100%', display:'flex', flexDirection: 'column', justifyContent: 'center', alignItems:'center', height: '100vh'}}>
                    <img src={LoadingImg} />
                    <p>Loading...</p>
                </div>
            )}
        >
            {!!Comp ? (<Comp />) : children}
        </Suspense>
    )
}

export default LazyRouteElement;